import invalidCartRedirectMiddleware from '#shared/middleware/invalidCartRedirectMiddleware.js';
import loadOrderMiddleware from '#shared/middleware/loadOrderMiddleware.js';
import paymentReturnMiddleware from '#shared/middleware/paymentReturnMiddleware.js';
import modifyTemplate from '#shared/util/modifyTemplate.js';

import defaultTemplate from '#themes/default/default/pages/thankYou/thankYou.html' with { type: 'html' };

import defaultThankYou from '#themes/default/default/pages/thankYou/thankYou.js';

import cBillingSummary from '#themes/default/web/components/billingSummary/billingSummary.js';
import cButton from '#themes/default/web/components/button/button.js';
import cCompanySummary from '#themes/default/web/components/companySummary/companySummary.js';
import cEmailButton from '#themes/default/web/components/emailButton/emailButton.js';
import cHeader from '#themes/default/web/components/header/header.js';
import cInfoBox from '#themes/default/web/components/infoBox/infoBox.js';
import cInstructionStep from '#themes/default/web/components/instructionStep/instructionStep.js';
import cOfflineInstructions from '#themes/default/web/components/offlineInstructions/offlineInstructions.js';
import cOrderSummary from '#themes/default/web/components/orderSummary/orderSummary.js';
import cProduct from '#themes/default/web/components/product/product.js';

import thankYouDetailsTemplate from './html/thankYou_details.html' with { type: 'html' };

const template = modifyTemplate(defaultTemplate, [{
	query: '.thankYou_details',
	position: 'before',
	content: thankYouDetailsTemplate
}]);

export default {
	middleware: [
		invalidCartRedirectMiddleware,
		paymentReturnMiddleware,
		loadOrderMiddleware
	],
	components: {
		cBillingSummary,
		cButton,
		cCompanySummary,
		cEmailButton,
		cHeader,
		cInfoBox,
		cInstructionStep,
		cOfflineInstructions,
		cOrderSummary,
		cProduct
	},
	extends: defaultThankYou,
	computed: {
		isAutoActivationSupported() {
			return this.order.products.some((product) => {
				const fulfillmentItem = product.fulfillment.license ? product.fulfillment.license.find((item) => ['walletkey', 'activationkey'].includes(item.contentType)) : null;
				return fulfillmentItem?.content && product.isBrowser;
			});
		},
		getHeadline() {
			if (this.payment.isOffline) {
				return this.t('thankYou_offlineInstructionsHeading');
			} else if (this.order.hasTrialProduct) {
				return this.t('thankYou_headingTrial');
			} else {
				return this.t('thankYou_heading');
			}
		},
		getStep2Text() {
			if (this.isAutoActivationSupported) {
				return '';
			} else {
				return this.t('thankYouInstructions_step2InstructionsDownload');
			}
		}
	},
	template
};
